// extracted by mini-css-extract-plugin
export default {"main":"Home_main__bEnMm","btnprimary":"Home_btnprimary__yoo8C","link":"Home_link__nk6bm"};